export default __webpack_public_path__ + "locales/pt/ChangeUserTypeDialog.json?hash=5d48a34841cc7679d1c4cf9838a2b6e2";